import { getRelease } from '../data/releases'
import { canShareFiles, downloadPdf, openPdf, sharePdf } from '../share/delivery'
import { button, el, toast } from '../ui/dom'
import { navigate } from '../router'

/**
 * What happened to the finished release, and how to get a copy off the device.
 *
 * Download is the primary action, not sharing. No web API can pre-address a
 * share target, so a button promising to "email it to Owen" could only ever
 * open the share sheet and hope: the file attaches, the address does not. A
 * button that does most of what its label says is worse than an honest one, so
 * the file goes to the phone and gets sent from there.
 */
export async function doneScreen(id: string): Promise<HTMLElement> {
  const release = await getRelease(id)
  if (!release) {
    navigate('/')
    return el('div')
  }

  const subject = `${release.templateTitle} - ${release.signerName}`
  const actions = el('div', { class: 'stack' })

  actions.append(
    button('Download the PDF', () => {
      downloadPdf(release.pdf, release.pdfFileName)
      toast('Saved to your downloads.')
    }, 'primary'),
  )

  if (canShareFiles()) {
    actions.append(
      button('Send it now…', () => {
        void sharePdf(release.pdf, release.pdfFileName, subject, `Signed ${subject}.`).then((r) => {
          if (r.message) toast(r.message)
        })
      }),
    )
  }

  actions.append(
    button('Open it', () => {
      if (!openPdf(release.pdf)) toast('The browser blocked opening it. Download it instead.')
    }),
    button('Next person', () => navigate('/'), 'primary'),
  )

  return el('div', { class: 'screen' }, [
    el('header', { class: 'app-bar' }, [el('h1', { class: 'app-title', text: 'Signed and saved' })]),
    el('p', { class: 'done-name', text: release.signerName || release.templateTitle }),
    el('p', { class: 'muted', text: `${release.pdfFileName} · ${release.pageCount} page` }),

    // Their address, selectable, because sending their copy happens later from
    // a mail app rather than from here.
    release.signerEmail
      ? el('p', { class: 'muted' }, [
          'Their email: ',
          el('span', { class: 'selectable', text: release.signerEmail }),
        ])
      : null,

    el('p', {
      class: 'warn',
      text: 'Download it now. Browser storage can be cleared and is not a permanent record.',
    }),
    actions,
  ])
}
